import React from "react";
import logoMobile from "../../../assets/logoa2.png";
import { useEffect } from "react";
import { FaRegStickyNote, FaRegEnvelope , FaWallet , FaExchangeAlt ,FaPlus} from "react-icons/fa";
import { SiDatabricks } from "react-icons/si";
import { AiOutlineUser, AiOutlineInfoCircle } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { expertContext } from "../../../context/expertcontext";
import Swal from "sweetalert2";

const Menu = () => {
  const { toggel, setToggel } = useContext(expertContext);

  useEffect(() => {
    if (window.innerWidth >= 992) {
      setToggel(true);
    } else {
      setToggel(false);
    }
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setToggel(true);
      } else {
        setToggel(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", handleResize);
    };
  }, []);

  const clicItem = () => {
    if (window.innerWidth <= 992) {
      setToggel(false);
    }
  };

  const confirmLogout = ()=>{
    Swal.fire({
      title: "خروج",
      text:"ایا قصد خارج  شدن از پنل را دارین؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله",
      cancelButtonText:"خیر"
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.pathname = '/'
      }
    })
  }

  return (
    <div className="" style={{ height: "90vh" }}>
      <div className={`expertpanel-menu ${toggel ? "expert-show-menu" : ""}`}>
        <img alt="" src={logoMobile} className="user-menu-logo" />
        <p className="expert-menu-label">پنل مدیریت کارشناس</p>
        <div className="mt-4">
          <ul className="userpanel-menu-list">
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/expert/requests"
            >
              <li className="mb-4">
                <FaRegStickyNote />
                &nbsp;&nbsp; درخواست / کارشناسی ها
              </li>
            </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/expert/new-request"
            >
              <li className="mb-4">
                <FaRegStickyNote />
                &nbsp;&nbsp; درخواست جدید
              </li>
            </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/expert/times"
            >
              <li className="mb-4">
                <SiDatabricks /> &nbsp;&nbsp; ساعات در دسترس
              </li>
            </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/expert/messages"
            >
              <li className="mb-4">
                <FaRegEnvelope /> &nbsp;&nbsp;صندوق پیام
              </li>
            </Link>
           {/*
           <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/expert/support"
            >
              <li className="mb-4">
                <AiOutlineUser /> &nbsp;&nbsp;پشتیبانی
              </li>
            </Link>
          */}
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/expert/statistics"
            >
              <li className="mb-4">
                <AiOutlineInfoCircle /> &nbsp;&nbsp;آمار
              </li>
            </Link>
            <Link
            onClick={() => clicItem()}
            className="userpanel-menu-list-item"
            to="/expert/wallet"
          >
            <li className="mb-4">
              <FaWallet /> &nbsp;&nbsp;کیف پول
            </li>
          </Link>
          <Link
          onClick={() => clicItem()}
          className="userpanel-menu-list-item"
          to="/expert/change-password"
        >
          <li className="mb-4">
            <FaExchangeAlt /> &nbsp;&nbsp;تغییر رمز
          </li>
        </Link>
            <Link
              className="userpanel-menu-list-item"
              
              onClick={() => {
                localStorage.removeItem("token");
              }}
            >
              <li className="mb-4">
              <div className=' request-Previous-btn-box mt-2 '>
            <button className='btn request-Previous-btn ' type='button' onClick={()=>{confirmLogout()}}>خروج</button>
            </div>
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Menu;
